import { render, staticRenderFns } from "./RInput.vue?vue&type=template&id=28f583ea&scoped=true&"
import script from "./RInput.vue?vue&type=script&lang=js&"
export * from "./RInput.vue?vue&type=script&lang=js&"
import style0 from "./RInput.vue?vue&type=style&index=0&id=28f583ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f583ea",
  null
  
)

/* custom blocks */
import block0 from "./RInput.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports